import { render, staticRenderFns } from "./MiniappshaichaStore.vue?vue&type=template&id=23e0797c&scoped=true&"
import script from "./MiniappshaichaStore.vue?vue&type=script&lang=js&"
export * from "./MiniappshaichaStore.vue?vue&type=script&lang=js&"
import style0 from "./MiniappshaichaStore.vue?vue&type=style&index=0&id=23e0797c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0797c",
  null
  
)

export default component.exports